import { render, staticRenderFns } from "./ProductsRow.vue?vue&type=template&id=99ea24bc&scoped=true&"
import script from "./ProductsRow.vue?vue&type=script&lang=js&"
export * from "./ProductsRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRow.vue?vue&type=style&index=0&id=99ea24bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ea24bc",
  null
  
)

export default component.exports